import React from 'react';

const usePreviousValue = <T>(value: T) => {
  const ref = React.useRef(value);

  React.useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};

export default usePreviousValue;
